export const de = {
    translation: {
        common: {
            account: 'Konto',
            loading: 'Wird geladen...',
            cancel: 'Abbrechen',
            close: 'Schließen',
            verifyCode: 'Code bestätigen',
            disable: 'Deaktivieren',
            setup: 'Einrichten',
            retry: 'Wiederholen',
        },
        shell: {
            pageTitle: '{{tenantName}} Konto',
            securityNav: 'Sicherheit',
            navigation: 'Kontonavigation',
            signOut: 'Abmelden',
            tenantSpace: 'Mandantenkonto',
        },
        states: {
            missingTenantTitle: 'Mandantenpfad fehlt',
            missingTenantDescription: 'Diese Konto-App erwartet eine URL im Format /t/:tenantSlug.',
            disabledTitle: 'Kontoverwaltung ist deaktiviert',
            disabledDescription: 'Dieser Mandant hat die Self-Service-Kontoverwaltung noch nicht aktiviert.',
            redirectingDescription: 'Weiterleitung zur Anmeldung...',
            redirectingBody: 'Sie benötigen eine aktive Sitzung, um dieses Konto zu verwalten.',
            notFoundTitle: 'Seite nicht gefunden',
            notFoundDescription: 'Die gesuchte Seite existiert nicht.',
            fatalErrorTitle: 'Dienst nicht verfügbar',
        },
        security: {
            title: 'Anmeldung und Sicherheit',
            description: 'Verwalten Sie Ihre Anmeldemethoden und die Sicherheit Ihres Kontos.',
            local: {
                title: 'Passwort und Verifizierung',
                externalCredentials: {
                    title: 'Von Ihrem Anmeldeanbieter verwaltet',
                    description:
                        'Ihr Passwort und Ihre Anmelde-Bestätigungsmethoden werden von dem Anbieter gesteuert, den Sie für den Zugriff auf dieses Konto verwenden.',
                },
                status: {
                    enabled: 'Aktiviert',
                    notSetUp: 'Nicht eingerichtet',
                },
                password: {
                    title: 'Passwort',
                    description: 'Ändern Sie Ihr Anmeldepasswort.',
                    unavailable: 'Die Anmeldung mit Passwort ist für dieses Konto nicht verfügbar.',
                    changeAction: 'Passwort ändern',
                    dialog: {
                        title: 'Passwort ändern',
                        description: 'Wählen Sie ein neues Passwort für zukünftige Anmeldungen.',
                        newPassword: 'Neues Passwort',
                        confirmPassword: 'Neues Passwort bestätigen',
                        confirmPasswordMismatch: 'Die Passwörter stimmen noch nicht überein.',
                        submit: 'Passwort aktualisieren',
                    },
                    requirements: {
                        title: 'Anforderungen',
                        length: 'Mindestens {{minLength}} Zeichen',
                        lower: 'Ein Kleinbuchstabe',
                        upper: 'Ein Großbuchstabe',
                        digit: 'Eine Ziffer',
                        special: 'Ein Sonderzeichen (z. B. - + _ ! @ # $ % ^ & * . , ? < > =)',
                        noRepeat: 'Nicht mehr als 2 identische Zeichen hintereinander',
                    },
                    messages: {
                        updated: 'Ihr Passwort wurde aktualisiert.',
                        updateError: 'Das Passwort konnte nicht geändert werden.',
                    },
                },
                authenticator: {
                    title: 'Authenticator-App',
                    description: 'Verifizierungscodes aus einer App.',
                    dialog: {
                        setup: {
                            title: 'Authenticator-App einrichten',
                            description:
                                'Scannen Sie diesen QR-Code mit Ihrer Authenticator-App. Falls das nicht möglich ist, können Sie den Einrichtungsschlüssel manuell eingeben.',
                            codeLabel: '6-stelligen Code eingeben',
                            copy: 'Kopieren',
                            copied: 'Kopiert',
                            submit: 'Code bestätigen',
                        },
                        manage: {
                            description:
                                'Ihr Konto verwendet bei der Anmeldung Verifizierungscodes aus Ihrer Authenticator-App.',
                        },
                        disable: {
                            title: 'Authenticator-App deaktivieren?',
                            description:
                                'Diese Verifizierungsmethode wird aus Ihrem Konto entfernt. Sie können sie später erneut einrichten.',
                            action: 'Authenticator-App deaktivieren',
                        },
                    },
                    messages: {
                        setupError: 'Die Einrichtung der Authenticator-App konnte nicht gestartet werden.',
                        enabled: 'Die Authenticator-App wurde aktiviert.',
                        disabled: 'Die Authenticator-App wurde deaktiviert.',
                        verifyError: 'Der Authenticator-Code konnte nicht bestätigt werden.',
                        disableError:
                            'Diese Verifizierungsmethode konnte nicht deaktiviert werden. Bitte versuchen Sie es erneut.',
                    },
                },
                email: {
                    title: 'E-Mail-Codes',
                    description: 'Verifizierungscodes per E-Mail.',
                    dialog: {
                        setup: {
                            title: 'E-Mail-Codes einrichten',
                            description:
                                'Geben Sie den Verifizierungscode ein, den wir an Ihre primäre E-Mail-Adresse gesendet haben.',
                            codeLabel: 'Verifizierungscode',
                            resend: 'Neuen Code senden',
                        },
                        manage: {
                            description:
                                'Ihr Konto verwendet bei der Anmeldung Verifizierungscodes, die an Ihre E-Mail-Adresse gesendet werden.',
                        },
                        disable: {
                            title: 'E-Mail-Codes deaktivieren?',
                            description:
                                'Diese Verifizierungsmethode wird aus Ihrem Konto entfernt. Sie können sie später erneut einrichten.',
                            action: 'E-Mail-Codes deaktivieren',
                        },
                    },
                    messages: {
                        setupError: 'E-Mail-Codes konnten nicht eingerichtet werden.',
                        verified: 'E-Mail-Codes wurden aktiviert.',
                        disabled: 'E-Mail-Codes wurden deaktiviert.',
                        verifyError: 'Der E-Mail-Code konnte nicht bestätigt werden.',
                        disableError:
                            'Diese Verifizierungsmethode konnte nicht deaktiviert werden. Bitte versuchen Sie es erneut.',
                    },
                },
            },
            connections: {
                title: 'Verknüpfte Konten',
                description: 'Verknüpfen Sie ein weiteres Konto, um es zur Anmeldung zu verwenden.',
                connectProvider: '{{provider}} verknüpfen',
                connecting: 'Wird verknüpft...',
                connected: 'Verknüpft',
                unavailable: 'Die Anmeldung mit diesem Anbieter ist derzeit nicht verfügbar.',
                providers: {
                    google: 'Google',
                    microsoft: 'Microsoft',
                },
                messages: {
                    connected: 'Ihr {{provider}}-Konto wurde verknüpft.',
                    alreadyConnected: 'Dieses {{provider}}-Konto ist bereits verknüpft.',
                    providerConflict: 'Sie haben bereits ein verknüpftes {{provider}}-Konto.',
                    accountInUse: 'Dieses {{provider}}-Konto ist bereits mit einem anderen Benutzer verknüpft.',
                    providerUnavailable: 'Die Anmeldung mit {{provider}} ist nicht mehr verfügbar.',
                    failed: 'Das Konto konnte nicht verknüpft werden. Bitte versuchen Sie es erneut.',
                },
            },
        },
        messages: {
            loadError: 'Die Kontoansicht konnte nicht geladen werden.',
            signOutSuccess: 'Sie wurden aus der Konto-App abgemeldet.',
            signOutError: 'Abmelden ist derzeit nicht möglich.',
        },
    },
}
